import { z } from 'zod'
import { ImageReferenceSchema } from './image'
import { SymbologySchema } from './primitives'
import { WarningSchema } from './warning'

export const RenderManifestSchema = z.object({
  zplSha256: z.string().regex(/^[a-f0-9]{64}$/, 'zplSha256 must be a 64-char hex string'),
  pngSha256: z
    .string()
    .regex(/^[a-f0-9]{64}$/, 'pngSha256 must be a 64-char hex string')
    .optional(),
  pipelineVersion: z.string(),
  generatedAt: z.string().datetime(),
  templateId: z.string(),
  templateVersion: z.string().optional(),
  printerProfileId: z.string(),
  printerProfileVersion: z.string().optional(),
  warnings: z.array(WarningSchema),
  usedFonts: z.array(z.string()),
  usedImages: z.array(ImageReferenceSchema),
  usedSymbols: z.array(SymbologySchema),
})
export type RenderManifest = z.infer<typeof RenderManifestSchema>
